import container from './container';

const mboxes = Object.keys(container);

// We expect the options array to only ever have one element
export const findMbox = (offers: any, mbox: any) =>
    offers?.execute?.mboxes?.find((x: any) => x.name === mbox)?.options?.[0];

// Whereas in the VEC field these correspond to each experiment
export const findVec = (offers: any) => offers?.execute?.pageLoad?.options;

// We can have many FBC experiments active at once
export const formTokens = (offers: any) => mboxes.map((mbox) => findMbox(offers, mbox)?.responseTokens).filter(Boolean);

// We can also have many VEC experiments active at once but if none are active return empty array
export const vecTokens = (offers: any) =>
    findVec(offers)
        ?.map((vec: any) => vec?.responseTokens)
        .filter(Boolean) ?? [];

// The `at` array is sent to quotations-web-orch, which only accepts a limited number of experiments per request
// and drops the rest. Be mindful of this if you're adding mboxes/experiments or otherwise growing `at`.
export const experimentParams = (offers: any) => {
    if (!offers) return undefined;

    // Combine logging for FBC and VEC experiments
    // If both are undefined, this just becomes an empty array
    const tokens = [...vecTokens(offers), ...formTokens(offers)].filter(Boolean);

    if (tokens.length === 0) return { at: {} };

    const value = tokens.map((token) => {
        return {
            tntId: token['profile.tntId'],
            activityId: token['activity.id'],
            activityName: token['activity.name'],
            experienceId: token['experience.id'],
            experienceName: token['experience.name']
        };
    });

    return { at: value };
};
